/**
 * @author Fernando Ruano
 * @file index.js
 * @description I18n translations root.
 */

// Dependencies
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Languages
import es from '@nephro/core/i18n/locales/es';
import en from '@nephro/core/i18n/locales/en';

const resources = {
  es: {
    translation: {
      ...es
    }
  },
  en: {
    translation: {
      ...en
    }
  }
};

i18n
  .use(Backend)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    lng: 'es',
    fallbackLng: 'es',
    resources,
    keySeparator: '.',
    supportedLngs: ['es', 'en'],
    interpolation: {
      escapeValue: false
    },
    debug: false
  });

export default i18n;
